<template>
  <el-dialog
    title="图片验证"
    :visible.sync="visible"
    :before-close="handleClose"
    width="350px"
    center>
    <div class="captcha-container">
      <div class="form-item">
        <el-input
          v-model="captchaValue"
          placeholder="请输入图片中的验证码"
          @keyup.enter.native="validateCaptcha">
        </el-input>
      </div>
      <div class="captcha-image-container">
        <img
          :src="captchaImageUrl"
          @click="refreshCaptcha"
          alt="验证码图片"
          class="captcha-image">
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="validateCaptcha">验证</el-button>
    </span>
  </el-dialog>
</template>

<script>
import axios from 'axios'
import { removeHTMLTag } from '@/util/util.js'

export default {
  name: 'CaptchaModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      uuid: '',
      captchaValue: '',
      captchaImageUrl: ''
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.refreshCaptcha()
      } else {
        this.captchaValue = ''
      }
    }
  },
  methods: {
    // 生成UUID
    generateUUID() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        return (c === 'x' ? (Math.random() * 16 | 0) : ('r&0x3' | '0x8')).toString(16)
      })
    },

    // 刷新验证码
    refreshCaptcha() {
      this.uuid = this.generateUUID();
      axios.get("/hpv/captcha.jpg", {
        params: {
          uuid: this.uuid
        },
        responseType: 'blob'
      }).then(response => {
        // 将返回的图片blob转换为URL
        const imageUrl = URL.createObjectURL(response.data);
        this.captchaImageUrl = imageUrl;
      })
    },

    // 验证验证码
    validateCaptcha() {
      if (!this.captchaValue) {
        this.$message({
          showClose: true,
          message: removeHTMLTag('请输入图片中的验证码'),
          type: 'error'
        });
        return false;
      }

      axios.post("/hpv/user/captcha.jpg/validate", {
        uuid: this.uuid,
        captcha: this.captchaValue
      }).then((response) => {
        let res = response.data;
        if (res.code == 0) {
          // 验证成功
          this.$emit('validate-success', this.uuid);
          this.handleClose();
        } else {
          this.refreshCaptcha();
        }
      }).catch(() => {
        this.$message({
          showClose: true,
          message: '验证失败，请重试',
          type: 'error'
        });
      });
    },

    handleClose() {
      this.$emit('update:visible', false);
    }
  }
}
</script>

<style scoped>
.captcha-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.form-item {
  flex: 1;
  margin-bottom: 0;
  margin-right: 15px;
}

.captcha-image-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.captcha-image {
  width: 120px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/CaptchaModal.vue